"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _imageDecor = _interopRequireDefault(require("./image-decor"));
var _motionParallax = _interopRequireDefault(require("../../../experiments/animation/motion-parallax"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ImageDecorContainer = /*#__PURE__*/(0, _react2.styled)(_motionParallax.default)({
  name: "ImageDecorContainer",
  class: "pl-i17j1wtm"
});

/**
 * DecorWrapper Component.
 *
 * @param {Object} props React props
 * @param {Object} props.decorImage1 Image 1
 * @param {Object} props.decorImage2 Image 2
 * @param {Object} props.decorImage3 Image 3
 * @param {Object} props.decorImageBg1 Background Image 1
 * @param {Object} props.decorImageBg2 Background Image 2
 * @returns {React.ReactElement} DecorWrapper Component
 * @public
 */

function DecorWrapper({
  decorImage1,
  decorImage2,
  decorImage3,
  decorImageBg1,
  decorImageBg2
}) {
  const parallaxSettings = (0, _react.useMemo)(() => ({
    targetClassName: 'img-decor-container',
    debugMode: false,
    speed: 0.5,
    maxTransformValue: 110
  }), []);
  const hasDecorImages = decorImage1 || decorImage2 || decorImage3;
  const hasBackgroundImages = decorImageBg1 || decorImageBg2;
  const getTransformStyle = (0, _react.useMemo)(() => {
    return {
      image1: transformY => ({
        transform: `translateY(${transformY * 0.25}%)`
      }),
      image2: transformY => ({
        transform: `translateY(-${transformY * 0.5}%)`
      }),
      image3: transformY => ({
        transform: `translateY(${transformY * 0.3}%)`
      })
    };
  }, []);
  if (!hasDecorImages && !hasBackgroundImages) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasDecorImages && /*#__PURE__*/_react.default.createElement(ImageDecorContainer, {
    id: "translate-y",
    settings: parallaxSettings
  }, ({
    transformY
  }) => {
    return /*#__PURE__*/_react.default.createElement("div", null, decorImage1 && /*#__PURE__*/_react.default.createElement(_imageDecor.default, {
      desktopWidth: "clamp(12rem, 24vw, 22rem)",
      desktopHeight: "clamp(12rem, 24vw, 22rem)",
      mobileWidth: "clamp(10rem, 30vw, 15rem)",
      mobileHeight: "clamp(10rem, 30vw, 15rem)",
      imgUrl: decorImage1?.url,
      desktopTop: "-3rem",
      desktopRight: "-2rem",
      mobileTop: "3rem",
      mobileRight: "-2rem",
      style: getTransformStyle.image1(transformY),
      className: "img-decor-container",
      triggerOnce: true
    }), decorImage2 && /*#__PURE__*/_react.default.createElement(_imageDecor.default, {
      desktopWidth: "clamp(18rem, 24vw, 16rem)",
      desktopHeight: "clamp(18rem, 24vw, 16rem)",
      mobileWidth: "clamp(7rem, 24vw, 20rem)",
      mobileHeight: "clamp(7rem, 24vw, 20rem)",
      imgUrl: decorImage2?.url,
      desktopBottom: "-6rem",
      desktopLeft: "-16rem",
      mobileBottom: "1rem",
      mobileLeft: "-21vw",
      style: getTransformStyle.image2(transformY),
      className: "img-decor-container",
      triggerOnce: true
    }), decorImage3 && /*#__PURE__*/_react.default.createElement(_imageDecor.default, {
      desktopWidth: "clamp(10rem, 24vw, 18rem)",
      desktopHeight: "clamp(10rem, 24vw, 18rem)",
      mobileWidth: "clamp(12rem, 29vw, 14rem)",
      mobileHeight: "clamp(12rem, 29vw, 14rem)",
      imgUrl: decorImage3?.url,
      desktopBottom: "-5rem",
      desktopRight: "-14rem",
      mobileBottom: "-5rem",
      mobileRight: "-9rem",
      style: getTransformStyle.image3(transformY),
      className: "img-decor-container",
      triggerOnce: true
    }));
  }), decorImageBg1 && /*#__PURE__*/_react.default.createElement(_imageDecor.default, {
    desktopWidth: "60rem",
    desktopHeight: "60rem",
    mobileWidth: "30rem",
    mobileHeight: "30rem",
    imgUrl: decorImageBg1?.url,
    desktopTop: "5%",
    desktopRight: "-40%",
    mobileTop: "10rem",
    mobileRight: "-10rem",
    zIndex: 0,
    triggerOnce: true
  }), decorImageBg2 && /*#__PURE__*/_react.default.createElement(_imageDecor.default, {
    desktopWidth: "50rem",
    desktopHeight: "50rem",
    mobileWidth: "25rem",
    mobileHeight: "25rem",
    imgUrl: decorImageBg2?.url,
    desktopTop: "-10%",
    desktopLeft: "-45%",
    mobileTop: "-2rem",
    mobileLeft: "-20rem",
    zIndex: 0,
    triggerOnce: true
  }));
}
var _default = exports.default = DecorWrapper;
DecorWrapper.propTypes = {
  decorImage1: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string
  }),
  decorImage2: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string
  }),
  decorImage3: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string
  }),
  decorImageBg1: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string
  }),
  decorImageBg2: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string
  })
};